export default __webpack_public_path__ + "static/media/DanskeNarrow-Italic.4d0fc10d.eot";